export const cookieExpirationDate = new Date();
cookieExpirationDate.setMonth(cookieExpirationDate.getMonth() + 6);
